import { RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import { Toaster } from 'react-hot-toast'

import store from 'src/store'
import router from 'src/router'
import ThemeComponent from 'src/theme/ThemeComponent'
import { SettingsProvider } from 'src/context/settingsContext'
import { AppearanceProvider } from 'src/context/appearanceContext'
import ReactHotToast from 'src/styles/libs/react-hot-toast'
import { useSettings } from 'src/hooks/useSettings'

import 'src/services/sentry'
import 'src/locale/i18n'

import 'react-perfect-scrollbar/dist/css/styles.css'
import 'src/styles/globals.css'
import 'src/styles/maily/tokens.css'
import 'reactflow/dist/style.css'

const AppNotifications = () => {
  const { settings } = useSettings()

  return (
    <ReactHotToast>
      <Toaster
        position={settings.toastPosition}
        toastOptions={{
          className: 'react-hot-toast',
          duration: 1000 * 5,
        }}
      />
    </ReactHotToast>
  )
}

const App = () => {
  return (
    <Provider store={store}>
      <SettingsProvider>
        <AppearanceProvider>
          <ThemeComponent>
            <RouterProvider router={router} />

            <AppNotifications />
          </ThemeComponent>
        </AppearanceProvider>
      </SettingsProvider>
    </Provider>
  )
}

export default App
